import React from 'react';
import { FormikProps } from 'formik';
import { NjffValues, PersonalInfoValues } from '@/data/Types';

const FormFieldErrorMessage = ({
    field,
    formik,
}: {
    field: string;
    formik: FormikProps<PersonalInfoValues> | FormikProps<NjffValues>;
}) => {
    const formikTouched: { [key: string]: unknown } = formik.touched;
    const formikErrors: { [key: string]: unknown } = formik.errors;

    return (
        <div className="form-field-error-container">
            {formikTouched[field] && formikErrors[field] ? (
                <div className="form-field-error-message">{formikErrors[field] as string}</div>
            ) : (
                <>&nbsp;</>
            )}
        </div>
    );
};

export default FormFieldErrorMessage;
